export const sortIconClassNames = {
    sortIcon: 'sort-icon',
    sortIconActive: 'sort-icon-active',
} as const;
